import { Check, ChevronDown, Plus, Trash2, X } from 'lucide-react'

import { tokenVar } from '../../utils'

export const CheckIcon = () => <Check size={12} aria-hidden />

export const XIcon = () => <X size={12} aria-hidden />

export const PlusIcon = () => <Plus size={16} aria-hidden />

export const TrashIcon = ({
  color = tokenVar('red.fg'),
}: {
  color?: string
}) => <Trash2 size={16} color={color} aria-hidden />

export const ChevronDownIcon = ({
  color = tokenVar('fg.default'),
}: {
  color?: string
}) => <ChevronDown size={20} strokeWidth={1.75} color={color} aria-hidden />
